import { render, staticRenderFns } from "./CustomerTrainingItemScorm.vue?vue&type=template&id=7faf99dc&scoped=true&"
import script from "./CustomerTrainingItemScorm.vue?vue&type=script&lang=js&"
export * from "./CustomerTrainingItemScorm.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTrainingItemScorm.vue?vue&type=style&index=0&id=7faf99dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7faf99dc",
  null
  
)

export default component.exports